/**
 * Customer Success — Hub d'actions client.
 *
 * Centralise l'état des modales/sidepanels autour d'un client donné :
 *   { modal: 'view'|'relance'|'message'|'call'|'email'|'task'|'note'|'quick'|'recommended', client, action }
 *
 * Utilisation :
 *   const { open, close, modal, client, action } = useClientActions();
 *   open('view', client);                       // Vue client
 *   open('recommended', client, actionObject);  // Détails action recommandée
 *
 * Pour exposer un toast cohérent, on s'appuie sur use-toast (sonner-like).
 */
import React, { createContext, useContext, useState, useCallback } from 'react';

const Ctx = createContext(null);

export function ClientActionsProvider({ children }) {
  const [state, setState] = useState({ modal: null, client: null, action: null });

  const open = useCallback((modal, client, action = null) => {
    setState({ modal, client: client || null, action: action || null });
  }, []);

  const close = useCallback(() => {
    setState({ modal: null, client: null, action: null });
  }, []);

  // Permet à une modale d'en ouvrir une autre sans flicker (passer à la relance, etc.)
  const switchModal = useCallback((modal) => {
    setState((s) => ({ ...s, modal }));
  }, []);

  return (
    <Ctx.Provider value={{ ...state, open, close, switchModal }}>
      {children}
    </Ctx.Provider>
  );
}

export function useClientActions() {
  const v = useContext(Ctx);
  if (!v) throw new Error('useClientActions must be used inside <ClientActionsProvider>');
  return v;
}
